// -------------------------------------------------------------------------------------------------
// Import
// -------------------------------------------------------------------------------------------------

import $ from 'jquery';
import {
  get as _get,
  trim as _trim,
} from 'lodash-es';
import BsModal from 'bootstrap/js/dist/modal';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'page-header-search';

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class PageSearchModal {
  constructor(el) {
    this.el = el;

    const searchField = $(el).find(`input[type="search"]`);
    const loadingIcon = $(el).find(`.ks-loading-icon`);
    const searchNoText = $(el).find(`.ks-search-no-text`);
    const searchResults = $(el).find(`.page-header-search__result`);
    const searchCountResults = $(el).find(`.page-header-search__result-count`);
    const searchNoResults = $(el).find(`.ks-search-no-text`);
    const searchAjax = $(el).find(`.page-header-search__ajax`);

    document.addEventListener('theme_search-autofocus', () => {
      this.el.addEventListener('transitionend', () => {
        searchField.focus();
      });
    });

    $(el).find(`form`).on('submit', function (e) {
      e.preventDefault();
    });

    searchField.on('keyup paste', function (e) {
      if (_trim(e.target.value).length === 0) {
        searchNoResults.remove();
        searchCountResults.hide();
        searchResults.find('.page-header-search__result-col-content').html('');
        searchResults.find('.diseases-therapies').parent().hide();
        searchResults.find('.locations').parent().hide();
        searchResults.find('.further-results').parent().hide();
        searchAjax.find('.error').remove();

        loadingIcon.hide('slow');
        searchNoText.show('slow');

        return;
      }

      if (_trim(e.target.value).length >= 3) {
        const formEl = e.currentTarget.parentNode;
        const formData = new FormData(formEl);

        loadingIcon.show();
        searchNoText.hide();
        searchAjax.find('.error').remove();

        $.ajax(formEl.getAttribute('action'), {
          data: formData,
          method: formEl.getAttribute('method'),
          processData: false,
          contentType: false,
          accept: 'application/json',
        }).done(({ success, message, data: results }) => {

          if (success === false) {
            searchNoResults.after('<p class="error">'+ message +'</p>');
            return;
          }

          searchCountResults.find('span').text(results.length);
          searchCountResults.show();

          searchResults.find('.diseases-therapies').parent().hide();
          searchResults.find('.locations').parent().hide();
          searchResults.find('.further-results').parent().hide();

          searchResults.find('.diseases-therapies').children().remove();
          searchResults.find('.locations').children().remove();
          searchResults.find('.further-results').children().remove();

          for (const el of results) {
            const getCol = el.column;
            const getUrl = el.url;
            const getHeadline = el.headline;
            const getText = el.text;
            const markup = $('<a href="'+ getUrl +'"><h4>'+ getHeadline +'</h4><p>'+ getText +'</p></a>');

            switch(getCol) {
              case 0:
                searchResults.find('.diseases-therapies').parent().show();
                markup.appendTo(searchResults.find('.diseases-therapies'));
                break;
              case 1:
                searchResults.find('.locations').parent().show();
                markup.appendTo(searchResults.find('.locations'));
                break;
              case 2:
                searchResults.find('.further-results').parent().show();
                markup.appendTo(searchResults.find('.further-results'));
                break;
            }
          }
        }).fail((jqXHR) => {
          let response = _trim(_get(jqXHR, 'responseText'));
          response = response.length ? response : 'Unbekannter Fehler';
          searchNoResults.after('<p class="error">'+ response +'</p>');
        }).always(() => {
          loadingIcon.hide();
        });
      }
    });
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => new PageSearchModal(el));
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
